import { createFileRoute } from '@tanstack/react-router';
import { Calendar, CreditCard, FileText } from 'lucide-react';

export const Route = createFileRoute('/_app/settings/billing')({
  component: BillingPage,
});

function BillingPage() {
  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">Billing</h1>
        <p className="mt-1 text-sm text-[color:var(--color-fg-muted)]">
          Plan actual, métodos de pago, y facturas históricas.
        </p>
      </header>

      <div
        className="rounded-lg border p-5 text-sm"
        style={{
          background: 'var(--color-bg-overlay)',
          borderColor: 'var(--color-border)',
        }}
      >
        <strong>Próximamente.</strong> Cuando habilitemos planes pagos vas a
        poder ver y cambiar tu suscripción acá.
      </div>

      {/* Mockup del plan card */}
      <section
        className="rounded-lg border p-5"
        style={{
          background: 'var(--color-bg-elevated)',
          borderColor: 'var(--color-border)',
        }}
      >
        <div className="flex items-center justify-between">
          <div>
            <div className="text-xs uppercase tracking-wide text-[color:var(--color-fg-muted)]">
              Plan actual
            </div>
            <div className="mt-1 text-lg font-semibold">Free (preview)</div>
            <div className="mt-0.5 text-xs text-[color:var(--color-fg-muted)]">
              Sin límites mientras estamos en preview.
            </div>
          </div>
          <CreditCard className="h-6 w-6 text-[color:var(--color-fg-subtle)]" aria-hidden />
        </div>
      </section>

      <section className="grid gap-3 sm:grid-cols-2">
        <SectionCard
          icon={<Calendar className="h-4 w-4" />}
          title="Métodos de pago"
          subtitle="Tarjeta crédito/débito, transferencia, cuenta corriente."
        />
        <SectionCard
          icon={<FileText className="h-4 w-4" />}
          title="Facturas históricas"
          subtitle="PDFs descargables + XML SII de cada mes facturado."
        />
      </section>
    </div>
  );
}

interface SectionCardProps {
  readonly icon: React.ReactNode;
  readonly title: string;
  readonly subtitle: string;
}

function SectionCard({ icon, title, subtitle }: SectionCardProps) {
  return (
    <div
      className="flex gap-3 rounded-lg border p-4"
      style={{
        background: 'var(--color-bg-elevated)',
        borderColor: 'var(--color-border)',
      }}
    >
      <div
        className="shrink-0 rounded-md p-2"
        style={{ background: 'var(--color-bg-overlay)', color: 'var(--color-fg-muted)' }}
      >
        {icon}
      </div>
      <div>
        <div className="text-sm font-medium">{title}</div>
        <div className="mt-0.5 text-xs text-[color:var(--color-fg-muted)]">{subtitle}</div>
      </div>
    </div>
  );
}
